import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "pantry-pr-food-view" }
const _hoisted_2 = { class: "pantry-pr-food-view-name" }
const _hoisted_3 = { class: "pantry-pr-food-view-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isShowImage())
      ? (_openBlock(), _createBlock("img", {
          key: 0,
          class: "pantry-pr-food-view-image",
          src: _ctx.getImage(),
          onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
        }, null, 40, ["src"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.getName()), 1),
    _createVNode("div", _hoisted_3, _toDisplayString(_ctx.getDescription()), 1),
    _withDirectives(_createVNode("div", {
      class: "pantry-pr-food-view-banner",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickBanner()))
    }, [
      _createVNode("img", {
        class: "pantry-pr-food-view-banner-image",
        src: _ctx.getBannerImage()
      }, null, 8, ["src"])
    ], 512), [
      [_vShow, _ctx.isShowBanner()]
    ])
  ]))
}